
<div class="mb-dialog mb-dialog-custom">
  <mb-dialog-header>
    <h3 class="mb-dialog-custom__header text">Beneficios de Hoteles Universal</h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <div class="benefits-info">
        <ul>
          <li *ngIf="dialogData.hasUniversalExpress">
            <div>
              <mb-icon class="icon icon-ticket" icon="ticket"></mb-icon>
            </div>
            <div class="text">
              <p>
                <strong i18n="@@pase_universal_express"
                  >Pase Universal Express Unlimited^</strong
                >
              </p>
              <p i18n="@@pase_universal_express_detail">
                Evita las filas normales en las atracciones más populares en Universal
                Studios Florida y Universal’s Islands of Adventure. Llega a la diversión
                aún más rápido con un Pase Universal Express*. Válido para quienes se
                alojen en: Hard Rock Hotel®, Loews Royal Pacific Resort y Loews Portofino
                Bay Hotel.
              </p>
            </div>
          </li>
          <li>
            <div>
              <mb-icon class="icon icon-clock" icon="clock"></mb-icon>
            </div>
            <div class="text">
              <p>
                <strong i18n="@@entrada_temprana">Entrada Temprana*</strong>
              </p>
              <p i18n="@@entrada_temprana_detail">
                Entrada Temprana al Parque para The Wizarding World of Harry Potter y
                Universal’s Volcano Bay una hora antes de que el parque temático abra las
                puertas. Admisión al parque temático es requerida.
              </p>
            </div>
          </li>
          <li>
            <div>
              <mb-icon class="icon icon-transfer" icon="transfer"></mb-icon>
            </div>
            <div class="text">
              <p>
                <strong i18n="@@transporte_gratuito">Transporte gratuito</strong>
              </p>
              <p i18n="@@transporte_gratuito_detail">
                Transporte gratuito a los parques temáticos y a Universal CityWalk.
              </p>
            </div>
          </li>
          <li>
            <div>
              <mb-icon class="icon icon-key" icon="bank-credit-card"></mb-icon>
            </div>
            <div class="text">
              <p>
                <strong i18n="@@paga_con_la_llave_de_la_habitacion"
                  >Paga con la llave de la habitación</strong
                >
              </p>
              <p i18n="@@paga_con_la_llave_de_la_habitacion_detail">
                Privilegios para pagar en todo el complejo con la llave de la habitación.
              </p>
            </div>
          </li>
          <li>
            <div>
              <mb-icon class="icon icon-packages" icon="packages"></mb-icon>
            </div>
            <div class="text">
              <p>
                <strong i18n="@@entrega_de_mercancia">Entrega de mercancía</strong>
              </p>
              <p i18n="@@entrega_de_mercancia_detail">
                Entrega gratuita en el hotel de las compras hechas dentro del complejo.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </mb-dialog-body>
</div>

